import template from "./objectTools.html";

/**
 * object-tools
 *
 * fetch ObjectTools.items and render them as the edit/manage menu in sidebar
 */
/* @ngInject */
export function objectTools(flux, ObjectTools, User, $location, _) {
  return {
    templateUrl: template,
    replace: true,
    scope: {},
    link: function($scope) {
      $scope.show = false;
      function update() {
        var here = $location.path(),
          abs = $location.absUrl();
        $scope.edit = _.map(ObjectTools.items || [], function(list) {
          if (_.isArray(list)) {
            return {
              url: list[0],
              active: list[0] === here || list[0] === abs,
              title: list[1],
              icon: list[2]
            };
          }
          return _.extend({}, list, {
            active: list.url === here
          });
        });
        $scope.show = $scope.edit.length > 0;
        // console.log(JSON.stringify($scope.edit, null, 2));
        // if (menu.is_admin && $('body').data('keywords')) {
        //   edit.push($sce.trustAsHtml('<a href="/Agent/manage_keywords?path=' + $window.document.location.pathname + '"><i class="fa fa-tags"></i> <span>Keywords</span></a>'));
        // }
      }
      if (User.isUser()) {
        update();
        flux.onChanged("ObjectTools", update, $scope);
        flux.onChanged("url", update, $scope);
      }
    }
  };
}

/**
 * object-tools-payload
 *
 * decodes object tools data from server side page
 * and sets to ObjectTools store
 */
/* @ngInject */
export function objectToolsPayload(flux, $log) {
  return {
    scope: false,
    link: function($scope, $element, $attr) {
      try {
        var payload = JSON.parse($attr.payload);
        flux.dispatch("set-object-tools", payload);
      } catch (e) {
        $log.error(e);
      }
    }
  };
}
